import { useState } from "react";
import FilterListIcon from "@mui/icons-material/FilterList";
import {
  Menu,
  MenuItem,
  ProSidebar,
  SidebarHeader,
  SubMenu,
} from "react-pro-sidebar";
import "react-pro-sidebar/dist/css/styles.css";
import { Box, useTheme } from "@mui/material";
import { tokens } from "../../../theme";

const FilterBox = ({ collapsed, setCollapsed }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  // const [collapsed, setCollapsed] = useState(false);
  const styles = {
    sideBarHeight: {
      minHeight: "145vh",
    },
    menuIcon: {
      float: "left",
      margin: "10px 0px 5px 0px",
      paddingLeft: "28px",
      cursor: "pointer",
    },
    menuIconCollapsed: {
      margin: "10px 0px 5px 0px",
      cursor: "pointer",
      border: "1px solid red",
    },
  };
  const onClickMenuIcon = () => {
    setCollapsed(!collapsed);
  };
  return (
    <Box
      sx={{
        "& .pro-sidebar-inner": {
          background: `${colors.whiteAccent[500]} !important`,
          borderRight: "2px solid #E8ECF5 !important",
        },
        "& .pro-icon-wrapper": {
          backgroundColor: "transparent !important",
        },
        "& .pro-inner-item": {
          padding: "5px 35px 5px 28px !important",
          color: `${colors.black[800]} !important`,
          visibility: !collapsed ? "visible" : "hidden",
        },
        "& .pro-inner-list-item": {
          background: `${colors.whiteAccent[500]} !important`,
          color: `${colors.black[800]} !important`,
        },
        "& .popper-inner": {
          display: "none !important",
        },
        "& .pro-sidebar .collapsed": {
          width: "80px",
        },
        "& .pro-inner-item:hover": {
          color: `${colors.primary[500]} !important`,
        },
        "& .pro-menu-item.active": {
          color: `${colors.primary[500]} !important`,
        },
      }}
    >
      <ProSidebar style={styles.sideBarHeight} collapsed={collapsed}>
        <SidebarHeader>
          <div style={styles.menuIcon} onClick={onClickMenuIcon}>
            <FilterListIcon sx={{ color: colors.primary[500] }} />
          </div>
        </SidebarHeader>
        <Menu iconShape="square">
          <SubMenu title="Game">
            <MenuItem colors={colors}>Axie Infinity</MenuItem>
            <MenuItem colors={colors}>Doodles</MenuItem>
            <MenuItem colors={colors}>Bored Apes</MenuItem>
            <MenuItem colors={colors}>Sandbox</MenuItem>
          </SubMenu>
          <SubMenu title="Collection">
            <MenuItem colors={colors}>Collection1</MenuItem>
            <MenuItem colors={colors}>Collection2</MenuItem>
            <MenuItem colors={colors}>Collection3</MenuItem>
            <MenuItem colors={colors}>Collection4</MenuItem>
            <MenuItem colors={colors}>Collection5</MenuItem>
            <MenuItem colors={colors}>Collection6</MenuItem>
          </SubMenu>
        </Menu>
      </ProSidebar>
    </Box>
  );
};
export default FilterBox;
